<span class="display-name">{{resource.name || resource.email}}</span>
